
import './App.css';
import Home from './Components/body/Home';
import { Footer } from './Components/Navbar/footer';
import Navbar from './Components/Navbar/navbar';
import { SideBar } from './Components/sideBar';


function App() {

  //background-image: url('https://wallpaperaccess.com/full/5486846.jpg');
 // background-size: 100% 100%;
  return (
    <div className="App">
         <Navbar/>
        
         <Home/>
         
    
       
    </div>
  );
}

export default App;
